import {requirePermission} from '@/modules/auth/permissions'
import {PharmacyForm} from '@/modules/pharmacies/components/pharmacy-form/pharmacy-form'
import {NewResourceFormContainer} from '@cypro/ui/components/ui/new-resource-form-container'
import {NewResourceFormHeader} from '@cypro/ui/components/ui/new-resource-form-header'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'
import * as z from 'zod'

const EditPharmacyPageSchema = z.object({
  pharmacyId: z.string().optional(),
})

export const Route = createFileRoute('/configuration/pharmacies/new')({
  beforeLoad: requirePermission('organisation.manage'),
  component: NewPharmacyContainer,
  validateSearch: EditPharmacyPageSchema,
})

function NewPharmacyContainer() {
  const {t} = useTranslate('wards')

  const {pharmacyId} = Route.useSearch()

  return (
    <NewResourceFormContainer>
      <NewResourceFormHeader
        title={pharmacyId ? t('edit_pharmacy_title') : t('new_pharmacy_title')}
        description={t('new_pharmacy_description')}
      />

      <PharmacyForm pharmacyId={pharmacyId} />
    </NewResourceFormContainer>
  )
}
